var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrijColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 20,
    viewBox: "0 0 52 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6177 15.3003C48.6177 16.3381 48.1427 16.8581 47.3319 16.8581C46.4613 16.8581 45.9472 16.2789 45.9472 15.081H42.5845C42.5845 18.2359 44.5821 19.9121 47.4308 19.9121C50.1806 19.9121 52 18.3149 52 15.3003V5.75653H48.6177V15.3003ZM33.6657 19.7728H37.0481V5.75653H33.6657V19.7728ZM11.0774 15.9597C11.0774 14.3624 10.0285 12.9254 8.40694 12.5853C9.75252 12.186 10.7611 11.0879 10.7611 9.39089C10.7611 7.17499 9.07973 5.75769 6.25058 5.75769H0V19.7728H6.46794C9.396 19.7728 11.0774 18.2754 11.0774 15.9597ZM7.31899 9.97011C7.31899 10.9289 6.706 11.428 5.5985 11.428H3.38233V8.49246H5.59735C6.706 8.49246 7.31899 9.01132 7.31899 9.97011ZM7.6548 15.5C7.6548 16.4983 7.00157 17.0171 5.87451 17.0171H3.38233V13.9225H5.83541C6.96247 13.9225 7.6548 14.5017 7.6548 15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3239 5.75568V19.7708H19.7063V14.48H20.5171L23.4049 19.7708H27.2231L24.019 14.22C26.1558 13.5816 27.1046 11.924 27.1046 10.1666C27.1046 7.7313 25.4037 5.75452 22.0006 5.75452H16.3239V5.75568ZM23.6636 10.3082C23.6636 11.4063 23.0702 12.0656 21.804 12.0656H19.7074V8.59143H21.804C23.0702 8.59143 23.6636 9.27048 23.6636 10.3082Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 0.0888062H0V2.34185H52V0.0888062Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 19.8224,
    transform: "translate(0 0.0888062)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrijColored);
export default __webpack_public_path__ + "static/media/brij-colored.cb940c89.svg";
export { ForwardRef as ReactComponent };